/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetUserGachaEnhancementResponse } from '../../models/set-user-gacha-enhancement-response';
import { UserServiceSetUserGachaEnhancementRequest } from '../../models/user-service-set-user-gacha-enhancement-request';

export interface UserServiceSetUserGachaEnhancement$Params {
  userUuid: string;
  gachaId: string;
      body: UserServiceSetUserGachaEnhancementRequest
}

export function userServiceSetUserGachaEnhancement(http: HttpClient, rootUrl: string, params: UserServiceSetUserGachaEnhancement$Params, context?: HttpContext): Observable<StrictHttpResponse<SetUserGachaEnhancementResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceSetUserGachaEnhancement.PATH, 'post');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.path('gachaId', params.gachaId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SetUserGachaEnhancementResponse>;
    })
  );
}

userServiceSetUserGachaEnhancement.PATH = '/api/v3/gateway/user/{userUuid}/gacha/{gachaId}/enhancement';
